import styled from 'styled-components';
import Tooltip from '../../tooltip/Tooltip';

export const MultiValueLabelTooltipStyled = styled(Tooltip)`
  min-width: 0;
`;
